/* Vero — nieuwsbrief: directe "Bedankt"-bevestiging zonder herladen (AJAX) */
(function () {
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('form.newsletter-form');
      if (!form) return;

      // Laat de browser ongeldige e-mailadressen zelf afvangen
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      event.preventDefault();

      const formData = new FormData(form);

      // Verstuur naar Shopify (slaat het adres op als abonnee); we wachten niet op de pagina
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
      }).catch(function () {
        /* stil falen: de bevestiging blijft staan */
      });

      // Toon de bedank-melding en verberg het formulier
      const wrapper = form.closest('.newsletter__wrapper') || form.parentElement;
      const thanks = wrapper ? wrapper.querySelector('.vero-newsletter-thanks') : null;
      const fieldWrapper = form.querySelector('.newsletter-form__field-wrapper');

      if (fieldWrapper) fieldWrapper.style.display = 'none';
      if (thanks) {
        thanks.hidden = false;
        thanks.setAttribute('tabindex', '-1');
        thanks.focus({ preventScroll: true });
      }
    },
    true
  );
})();
